export const CloseIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Close Icon</title>
      <path d="M14 2L2 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1.46967 1.46967C1.76256 1.17678 2.23732 1.17678 2.53022 1.46967L14.5302 13.4697C14.8231 13.7626 14.8231 14.2373 14.5302 14.5302C14.2373 14.8231 13.7626 14.8231 13.4697 14.5302L1.46967 2.53022C1.17678 2.23732 1.17678 1.76256 1.46967 1.46967Z"
        fill="currentColor"
      />
    </svg>
  )
}
